import {
  Scene,
  AmbientLight,
  DirectionalLight,
  PerspectiveCamera,
  Box3,
  Vector3,
} from 'three';
import {traverseMaterials} from './materials.js';
import {getCanvasBlob} from './thumbnails.js';
import makeRenderer from './makeRenderer';
import { getThemeColor } from './theme.js';

export default class ThumbnailRenderer {
  constructor() {
    this.renderer = makeRenderer(512, 512);
  }

  generateThumbnail = async (object, width = 256, height = 256) => {
    const scene = new Scene();
    scene.add(object);

    const light2 = new DirectionalLight(0xffffff, 0.8 * Math.PI);
    light2.position.set(0.5, 0, 0.866);
    scene.add(light2);

    scene.add(new THREE.HemisphereLight(0xb1e3ff, 0xb1e3ff, 2.5));


    const camera = new PerspectiveCamera();
    scene.add(camera);

    scene.background = new THREE.Color('#3A4048');

    traverseMaterials(object, (material) => {
      if (
        material.isMeshStandardMaterial ||
        material.isGLTFSpecularGlossinessMaterial
      ) {
        // material.envMap = environmentMap;
        material.needsUpdate = true;
      }
    });

    object.updateMatrixWorld();

    const box = new Box3().setFromObject(object);
    const size = box.getSize(new Vector3()).length();
    const center = box.getCenter(new Vector3());

    camera.near = size / 100;
    camera.far = size * 100;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    camera.position.copy(center);
    camera.position.x += size;
    camera.position.y += size / 2;
    camera.position.z += size;
    camera.lookAt(center);

    camera.layers.disable(1);

    this.renderer.setSize(width, height, true);
    this.renderer.render(scene, camera);

    const blob = await getCanvasBlob(this.renderer.domElement);

    return blob;
  };
}
